import React from 'react';
import {
  Delete,
  Watch,
  Exclude,
  ToCRM,
  Return,
  BlockAuthor,
  MuteAuthor,
  UnmuteAuthor,
  PinTitle
} from '../Actions';
import ToPodiumTitle from '../Actions/ToPodiumTitle';
import ToContacted from '../Actions/ToContacted';

import {
  ALL_NEW_TITLE,
  HOT_TITLES,
  MANUALLY_ADDED,
  PODIUM_TITLES,
  WATCHLIST,
  ALL_TITLES_RR,
  POPULAR,
  WATCHLIST_RR,
  TRENDING,
  RISING_STARS,
  SENT_TO_CRM_RR,
  SEND_TO_CRM,
  ALL_EXCLUDED_RR,
  ALL_EXCLUDED,
  COMPETITORS,
  PODIUM_TITLES_RR,
  MUTED_AUTHORS,
  MUTED_AUTHORS_RR,
  POPULAR_AO3,
  SENT_TO_CRM_AO3,
  WATCHLIST_AO3,
  PODIUM_TITLES_AO3,
  ALL_EXCLUDED_AO3,
  MUTED_AUTHORS_AO3
} from '../../core/constants';

import { useUserPermit } from '../../context/User.context';

interface IOverlayActionProps {
  book: any;
  TAB_ID: string;
  refetchTable?: Function;
}

// Config
const PODIUM_DISABLED_TABS = new Set([
  PODIUM_TITLES,
  PODIUM_TITLES_RR,
  POPULAR,
  RISING_STARS,
  TRENDING,
  PODIUM_TITLES_AO3
]);

const RETURN_DISABLED_TABS = new Set([
  ALL_NEW_TITLE,
  ALL_TITLES_RR,
  MANUALLY_ADDED,
  HOT_TITLES,
  POPULAR,
  RISING_STARS,
  TRENDING,
  MUTED_AUTHORS,
  MUTED_AUTHORS_RR,
  POPULAR_AO3
]);

const EXCLUDE_DISABLED_TABS = new Set([
  ALL_EXCLUDED_RR,
  ALL_EXCLUDED,
  PODIUM_TITLES,
  PODIUM_TITLES_RR,
  COMPETITORS,
  ALL_EXCLUDED_AO3,
  PODIUM_TITLES_AO3
]);

const CONTACTED_TABS = new Set([
  ALL_NEW_TITLE,
  ALL_TITLES_RR,
  WATCHLIST,
  WATCHLIST_RR,
  HOT_TITLES,
  MUTED_AUTHORS,
  MUTED_AUTHORS_RR,
  POPULAR_AO3,
  WATCHLIST_AO3,
  MUTED_AUTHORS_AO3
]);

const CRM_DISABLED_TABS = new Set([
  SEND_TO_CRM,
  SENT_TO_CRM_RR,
  SENT_TO_CRM_AO3
]);

const MUTE_AUTHOR_ENABLED_TABS = new Set([
  ALL_NEW_TITLE,
  ALL_TITLES_RR,
  POPULAR_AO3
]);

const UNMUTE_AUTHOR_TABS = new Set([
  MUTED_AUTHORS,
  MUTED_AUTHORS_RR,
  MUTED_AUTHORS_AO3
]);

const PIN_TITLE_TABS = new Set([
  WATCHLIST,
  WATCHLIST_RR,
  WATCHLIST_AO3
]);

// Component
const OverlayActions: React.FC<IOverlayActionProps> = ({
  book,
  TAB_ID
}) => {
  const { edit_titles, move_titles_hubspot } = useUserPermit();
  const showPodium = !PODIUM_DISABLED_TABS.has(TAB_ID);
  const showReturn = !RETURN_DISABLED_TABS.has(TAB_ID);
  const showExclude = !EXCLUDE_DISABLED_TABS.has(TAB_ID);
  const showContacted = CONTACTED_TABS.has(TAB_ID);
  const showCRM = move_titles_hubspot && !CRM_DISABLED_TABS.has(TAB_ID);
  const showWatch = TAB_ID !== WATCHLIST && TAB_ID !== WATCHLIST_RR && TAB_ID !== WATCHLIST_AO3;
  const showMuteAuthor = MUTE_AUTHOR_ENABLED_TABS.has(TAB_ID);
  const showUnmuteAuthor = UNMUTE_AUTHOR_TABS.has(TAB_ID);
  const showPinTitle = PIN_TITLE_TABS.has(TAB_ID);

  if (!edit_titles) {
    return null;
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'end' }}>
      <div className='overlay-actions'>
        {showWatch && (<Watch book={book} id={TAB_ID} />)}
        {showPinTitle && <PinTitle book={book} id={TAB_ID} />}
        {showPodium && (<ToPodiumTitle book={book} id={TAB_ID} />)}
        {showContacted && (<ToContacted book={book} id={TAB_ID} />)}
        {showCRM && <ToCRM book={book} id={TAB_ID} />}
        {showUnmuteAuthor && <UnmuteAuthor book={book} id={TAB_ID} />}
        {showExclude && <Exclude book={book} id={TAB_ID} />}
        {showReturn && <Return book={book} id={TAB_ID} />}
        {showMuteAuthor && <MuteAuthor book={book} id={TAB_ID} />}
        <BlockAuthor book={book} id={TAB_ID} />
        <Delete book={book} id={TAB_ID} />
      </div>
    </div>
  );
};

export default OverlayActions;